module.exports = __webpack_public_path__ + "img/pic4.d2c4d64f.png";